// Module
var code = "<script>let $ctrl</script> <button class=\"button button--activate\" type=\"button\" title=\"{{ 'dc2fb62f-0cde-41d6-9015-2e5a170b4da0' | translate }}\" ng-click=\"$ctrl.activate()\" ng-disabled=\"$ctrl.disabled\" name=\"button-active\"> <atom-text class=\"button__text\"> <ng-transclude></ng-transclude> </atom-text> </button> ";
// Exports
module.exports = code;